export default "__VITE_ASSET__AMg0JE1$__"